// 返回左侧阵型在指定行的人数，保持现有 15 种阵型编号的业务定义。
export function getFormationLineCount(type, position) {
    if (position === 1) return 1

    if (position === 2) {
        if ([1, 2, 5, 13, 14].includes(type)) return 3
        if ([3, 7, 8, 10, 15].includes(type)) return 4
        if ([4, 6, 9, 11, 12].includes(type)) return 5
    }

    if (position === 3) {
        if (type === 1) return 2
        if ([2, 4, 12, 13, 15].includes(type)) return 3
        if ([3, 6, 8, 9, 14].includes(type)) return 4
        if ([5, 7, 10, 11].includes(type)) return 5
    }

    if (position === 4) {
        if ([2, 6, 7, 11, 14, 15].includes(type)) return 1
        if ([1, 3, 4, 5, 9, 10, 13].includes(type)) return 2
        if ([8, 12].includes(type)) return 3
    }

    return [1, 2, 3, 4].includes(position) ? undefined : 5
}

// 右侧阵型按镜像行号计算；裁判行只在最后一行展示一个位置。
export function getMirroredFormationLineCount(type, position, gameType) {
    if ([1, 2].includes(gameType)) {
        return position === 4 ? 1 : 0
    }

    return getFormationLineCount(type, 5 - position)
}
